import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '../fragments';

export const startScheduledSessionMutation = gql`
  mutation StartScheduledSession($id: ID!) {
    startScheduledSession(id: $id) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;